import { Routes } from '@angular/router'

export const PUBLIC_ROUTES: Routes = [
    { path: 'register', loadComponent: () => import('./register/register.component').then((m) => m.RegisterComponent) },
    {
        path: 'register/success',
        loadComponent: () =>
            import('./register/registration-success.component').then((m) => m.RegistrationSuccessComponent),
    },
    {
        path: 'auth',
        loadComponent: () => import('./auth/auth.component').then((m) => m.AuthComponent),
    },
    {
        path: 'forbidden',
        loadComponent: () => import('./forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
    },
    { path: 'error', loadComponent: () => import('./error/error.component').then((m) => m.ErrorComponent) },
]
